// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"ec32954a","267":"bec834a0","297":"87997aea","688":"538cbb77","725":"14569c74"}[chunkId] + ".chunk.js";
};